import type { PatentJpdcExtend } from '../types';
import type { ApiGetPatentBasicResponse } from '@/infrastructure/api-functions/core-search-api/get-patent-basic-api';

export interface GetPatentJpdcDTO {
    getPatentJpdc(data: ApiGetPatentBasicResponse['JPDC_DTERM']): PatentJpdcExtend;
}

export const GetPatentJpdcDTO = Symbol.for('GetPatentJpdcDTO');
